import { Assignment, BarChart, TrendingUp } from "@material-ui/icons";
import FormsPage from "./configurations/forms";
import StatisticsPage from "./configurations/statistics";
import ProductionStatisticsPage from "./configurations/production-statistics";
import {
	Divider,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	ListSubheader,
	useTheme,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import type { ConfigurationsType } from "@dexteel/mesf-core/dist/configurationMenu";

const components = [
	{
		path: "forms",
		sidebar: () => <div>Forms</div>,
		main: () => <FormsPage />,
	},
	{
		path: "statistics",
		sidebar: () => <div>Statistics</div>,
		main: () => <StatisticsPage />,
	},
	{
		path: "production-statistics",
		sidebar: () => <div>System Activity</div>,
		main: () => <ProductionStatisticsPage />,
	},
];

const sidebar = ({ option }: { option?: string }) => {
	const theme = useTheme();

	return (
		<>
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Form Settings
					</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "forms"}
					component={Link}
					to="/configuration/forms"
				>
					<ListItemIcon>
						<Assignment />
					</ListItemIcon>
					<ListItemText primary="Forms" />
				</ListItem>
			</List>
			<Divider />
			<List
				subheader={
					<ListSubheader
						style={{
							backgroundColor: theme.palette.background.paper,
							color: theme.palette.primary.main,
							fontWeight: 600,
						}}
					>
						Statistics
					</ListSubheader>
				}
			>
				<ListItem
					button
					selected={option === "statistics"}
					component={Link}
					to="/configuration/statistics"
				>
					<ListItemIcon>
						<BarChart />
					</ListItemIcon>
					<ListItemText primary="System Usage" />
				</ListItem>
				<ListItem
					button
					selected={option === "production-statistics"}
					component={Link}
					to="/configuration/production-statistics"
				>
					<ListItemIcon>
						<TrendingUp />
					</ListItemIcon>
					<ListItemText primary="System Activity" />
				</ListItem>
			</List>
			<Divider />
		</>
	);
};
const customConfigurations: ConfigurationsType = [components, sidebar];

export { customConfigurations };
